//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import Episodes from "@/components/episodes.comp.vue";
import Cast from "@/components/cast.comp.vue";
import Crew from "@/components/crew.comp.vue";
export default {
  name: "SingleTvshows",
  data() {
    return {
      singleShow: {},
      tab: "episodes",
      splitterModel: 20
    };
  },
  beforeMount() {
    this.$store.dispatch("getTvShowDetails", this.$route.params.id);
  },
  computed: {
    ...mapGetters(["tvshows", "tvshowsDetails", "seasons", "casts", "crews", "tabs"])
  },
  components: {
    Episodes,
    Cast,
    Crew
  }
};
